import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7ea19c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }

import room, { State } from '@/store/lives/home';
import Layout from '@/views/layouts/desktop/Root.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Channels from './Channels.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[room.name])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, { "left-width": 220 }, {
    "left-side": _withCtx(() => [
      _createVNode(Channels)
    ]),
    "top-bar": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(data).live?.title), 1)
    ]),
    _: 1
  }))
}
}

})